// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const about = {
  getAbout(page,search,sort_order) {
    return AuthService.get(`/about/about?page=${page}&search=${search}&sort_order=${sort_order}`);
  },
  showAbout(id) {
    return AuthService.get(`/about/about/${id}`);
  },
  createAbout(data) {
    return AuthService.post("/about/about", data);
  },
  updateAbout(id, data) {
    return AuthService.put(`/about/about/${id}`, data);
  },
  deleteAbout(id) {
    return AuthService.delete(`/about/about/${id}`);
  }
};
export default about;
